import React, { Fragment } from 'react';

import FilterSelector from '../../FilterSelector/FilterSelector';
import SkeletonLoader from '../../SkeletonLoader/SkeletonLoader';

const NewPostFilter = ({ previewImage, setPreviewImage, filters }) => {
  const isVideo = previewImage.type === 'video';

  return (
    <Fragment>
      <div className="new-post__preview">
        <div className="new-post__preview-image-container">
          {previewImage.src ? (
            isVideo ? (
              <video
                src={previewImage.src}
                controls
                controlsList="nodownload"
                onContextMenu={(event) => event.preventDefault()}
                playsInline
                muted
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <img
                src={previewImage.src}
                alt="Customize"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                  filter: previewImage.filter,
                }}
              />
            )
          ) : (
            <SkeletonLoader />
          )}
        </div>
      </div>
      {isVideo ? (
        <div className="new-post__filter-empty">
          Video filters aren&apos;t available yet. Tap Next to add your caption.
        </div>
      ) : (
        <FilterSelector
          setFilter={(filter, filterName) =>
            setPreviewImage((previous) => ({ ...previous, filter, filterName }))
          }
          previewImage={previewImage.src}
          filters={filters}
        />
      )}
    </Fragment>
  );
};

export default NewPostFilter;
